import { Trans } from 'react-i18next';
import CryogenicSection2Image2Poster from '../../assets/cryogenic_section2_image2.jpg';
import CryogenicSection2Image2 from '../../assets/cryogenic_section2_image2.mp4';
import CryogenicSection2Image5 from '../../assets/cryogenic_section2_image5.png';
import CryogenicSection2Image6 from '../../assets/cryogenic_section2_image6.png';
import CryogenicSection2Image7 from '../../assets/cryogenic_section2_image7.png';
import CryogenicSection2Image7Cha from '../../assets/cryogenic_section2_image7_cha.png';
import CryogenicSection2Image7Eng from '../../assets/cryogenic_section2_image7_eng.png';
import { CenterLayout, HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H4, H7, Point2, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';

const CryogenicPipingSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(213)}`} />
      {isMobile ? (
        <VerticalLayout>
          <CenterLayout>
            <H4 style={{ textAlign: 'center' }}><Trans i18nKey='최대 -271℃의 에너지를 다루는 기술 비비테크의 극저온 배관 솔루션' /></H4>
          </CenterLayout>
          <BTBox height={isMobile ? 24 : 34} />
          <video
            src={CryogenicSection2Image2}
            autoPlay
            muted
            loop
            playsInline
            poster={CryogenicSection2Image2Poster}
            onPlay={() => trackVideoPlay('극저온배관', 'cryogenic_piping', 0)}
            style={{
              width: '100%',
              height: '400px',
              display: 'block',
              objectFit: 'cover',
            }}
          />
        </VerticalLayout>
      ) : (
        <VerticalLayout>
          <CenterLayout>
            <H4><Trans i18nKey='최대 -271℃의 에너지를 다루는 기술 비비테크의 극저온 배관 솔루션' /></H4>
          </CenterLayout>
          <BTBox height={`${pxToRem(55)}`} />
          <div style={{ width: '100%' }}>
            <video
              src={CryogenicSection2Image2}
              autoPlay
              muted
              loop
              playsInline
              poster={CryogenicSection2Image2Poster}
              onPlay={() => trackVideoPlay('극저온배관', 'cryogenic_piping', 0)}
              style={{
                width: '100%',
                display: 'block',
                objectFit: 'cover',
              }}
            />
          </div>
        </VerticalLayout>
      )}
      <BTBox height={isMobile ? 60 : pxToRem(127)} />

      {isMobile ? (
        <VerticalLayout>
          <VerticalLayout style={{ flex: 1 }}>
            <CenterLayout>
              <H4 style={{
                ...isChina ? {wordBreak: 'break-word'} : {}
              }}><Trans i18nKey='극저온 유체는 온도 변화에 따라 재료의 수축·팽창이 심하고, 누설·결로·단열 문제가 발생하기 쉬워, 정밀한 설계와 고도 기술이 필수적입니다.' /></H4>
            </CenterLayout>
            <BTBox height={24} />
            <CenterLayout>
              <Body1 style={{ opacity: '0.5' }}><Trans i18nKey='주로 반도체 공정에서 장비 내부(Chamber)와 외부 냉각장치(Chiller)를 연결하는 냉매(Coolant)배관에 사용됩니다.' /></Body1>
            </CenterLayout>
          </VerticalLayout>
        </VerticalLayout>
      ) : (
        <VerticalLayout>
          <CenterLayout>
            <H7>
              <Trans i18nKey='극저온 유체는 온도 변화에 따라 재료의 수축·팽창이 심하고, 누설·결로·단열 문제가 발생하기 쉬워, 정밀한 설계와 고도 기술이 필수적입니다.' />
            </H7>
          </CenterLayout>
          <BTBox height={`${pxToRem(55)}`} />
          <CenterLayout>
            <Body1>
              <Trans i18nKey='주로 반도체 공정에서 장비 내부(Chamber)와 외부 냉각장치(Chiller)를 연결하는 냉매(Coolant)배관에 사용됩니다.' />
            </Body1>
          </CenterLayout>
        </VerticalLayout>
      )}

      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />

      <HorizontalEqualLayout style={{
        width: '100%', alignItems: 'start',
        ...isMobile ? { flexDirection: 'column' } : {}
      }} gap={40}>
        <VerticalLayout style={{ flex: 1 }}>
          <img src={CryogenicSection2Image5} style={{ width: '100%' }} />
          <BTBox height={isMobile ? 16 : `${pxToRem(33)}`} />
          <Point2>
            <Trans i18nKey='내부 쿨런트와 외부온도 차이에 의한 수분 발생' />
          </Point2>
        </VerticalLayout>
        <VerticalLayout style={{ flex: 1 }}>
          <img src={CryogenicSection2Image6} style={{
            width: '100%',
            border: '1px solid rgba(0, 0, 0, 0.4)',
          }} />
          <BTBox height={`${pxToRem(33)}`} />
          <VerticalLayout style={{
            ...isMobile ? { flexDirection: 'row' } : {}
          }}>
            <Point2>
              <Trans i18nKey='이중 진공배관을 시공' />
            </Point2>
            {isMobile && <BTBox width={3} />}
            <Point2 style={{ fontWeight: isMobile ? '700' : '400' }}>
              <Trans i18nKey='(저온 진공 단열 밸브)' />
            </Point2>
          </VerticalLayout>
        </VerticalLayout>
      </HorizontalEqualLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(160)}`} />
      {isMobile && (
        <>
          <div style={{ width: '100%', height: '1px', backgroundColor: 'black', opacity: '0.4' }} />
          <BTBox height={`16px`} />
        </>
      )}
      <H7>
        <Trans i18nKey='극저온 식각 공정의 효율성 및 비교 설명' />
      </H7>
      <BTBox height={isMobile ? 8 : `${pxToRem(32)}`} />

      <HorizontalEqualLayout style={{
        width: '100%', alignItems: 'start',
        ...isMobile ? { flexDirection: 'column' } : {}
      }} gap={isMobile ? 16 : 40}>
        <VerticalLayout style={{ flex: 1 }}>
          <img src={isEng ? CryogenicSection2Image7Eng : isChina ? CryogenicSection2Image7Cha : CryogenicSection2Image7} style={{ width: '100%' }} />
        </VerticalLayout>
        <VerticalLayout style={{ flex: 1 }}>
          <HorizontalLayout style={{ width: '100%', alignItems: 'start' }}>
            <Text4 style={{ fontWeight: '700' }}>1</Text4>
            <BTBox width={20} />
            <Text4 style={{
              flex: 1,
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}><span style={{ fontWeight: 700 }}><Trans i18nKey='비비테크의 기술력' /></span> : <Trans i18nKey='비비테크는 극저온 이중 배관 기술을 적용하여, 식각 공정이 상온에서 진행될 때 발생할 수 있는 여러 문제점을 효과적으로 억제합니다. 그 결과, 직진 식각이 가능하여 고품질 공정이 구현됩니다.' /></Text4>
          </HorizontalLayout>
          <BTBox height={isMobile ? 16 : `${pxToRem(30)}`} />
          <Text4 style={{ fontWeight: '700', opacity: 0.5 }}>
            <Trans i18nKey='식각 공정이 상온에서 진행될 경우 발생 가능한 문제점' />
          </Text4>
          <BTBox height={isMobile ? 8 : `${pxToRem(8)}`} />
          <HorizontalLayout style={{ width: '100%', alignItems: 'start', opacity: 0.5 }}>
            <Text4 style={{
              fontWeight: '700',
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}>2</Text4>
            <BTBox width={20} />
            <Text4 style={{
              flex: 1,
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}><span style={{ fontWeight: 700 }}><Trans i18nKey='Incomplete Etch (식각 불완전)' /></span> : <Trans i18nKey='식각이 끝까지 진행되지 않아 잔존물이 남는 현상' /></Text4>
          </HorizontalLayout>
          <HorizontalLayout style={{ width: '100%', alignItems: 'start', opacity: 0.5 }}>
            <Text4 style={{ fontWeight: '700' }}>3</Text4>
            <BTBox width={20} />
            <Text4 style={{
              flex: 1,
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}><span style={{ fontWeight: 700 }}><Trans i18nKey='Bowing (내부 불록 형상)' /></span> : <Trans i18nKey='식각된 구조가 휘거나 굴곡지는 형상으로 변형됨' /></Text4>
          </HorizontalLayout>
          <HorizontalLayout style={{ width: '100%', alignItems: 'start', opacity: 0.5 }}>
            <Text4 style={{
              fontWeight: '700',
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}>4</Text4>
            <BTBox width={20} />
            <Text4 style={{ flex: 1 }}><span style={{
              fontWeight: 700,
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}><Trans i18nKey='Twisting (비직진 식각)' /></span> : <Trans i18nKey='구조물이 휘거나 꼬이는 등의 형태로 식각돼 정밀도가 떨어짐' /></Text4>
          </HorizontalLayout>
          <HorizontalLayout style={{ width: '100%', alignItems: 'start', opacity: 0.5 }}>
            <Text4 style={{
              fontWeight: '700',
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}>5</Text4>
            <BTBox width={20} />
            <Text4 style={{ flex: 1 }}><span style={{
              fontWeight: 700,
              ...isMobile ? { fontSize: '14px', lineHeight: '24px' } : {}
            }}><Trans i18nKey='CD(선폭) 편차 발생' /></span> : <Trans i18nKey='식각 상단과 하단의 선폭이 달라지는 불균일 현상 발생' /></Text4>
          </HorizontalLayout>
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 86 : 220} />
    </VerticalLayout>
  );
};

export default CryogenicPipingSection2;
